/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.25"
        height="82.25"
        viewBox="0 0 82.25 82.25"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M41.04 1.28a1.25 1.25 0 0 1 1.24 1.13V79.5a1.25 1.25 0 0 1-2.49.13V2.5a1.25 1.25 0 0 1 1.25-1.22Z"
          fill="#0e497b"
          className="icon-fill icon-base"/><path
          d="M79.5 39.97a1.25 1.25 0 0 1 .13 2.49H2.5a1.252 1.252 0 0 1-.13-2.5H79.5Z"
          fill="#0e497b"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M29.11 19.66a1.25 1.25 0 0 1 .13 2.49H12.05a1.252 1.252 0 0 1-.13-2.5h17.19ZM69.16 19.66a1.25 1.25 0 0 1 .13 2.49H52.1a1.252 1.252 0 0 1-.13-2.5h17.19ZM69.16 55.3a1.25 1.25 0 0 1 .13 2.49H52.1a1.252 1.252 0 0 1-.13-2.5h17.19ZM69.16 64.82a1.252 1.252 0 0 1 .13 2.5H52.1a1.25 1.25 0 0 1-.13-2.49h17.19Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M20.58 11.13a1.24 1.24 0 0 1 1.24 1.12v17.19a1.25 1.25 0 0 1-2.49.13V12.38a1.25 1.25 0 0 1 1.25-1.25ZM25.73 54.04a1.25 1.25 0 0 1 1.86 1.67l-.1.1-12.06 12.07a1.25 1.25 0 0 1-1.86-1.67l.09-.1Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M13.66 54.04a1.27 1.27 0 0 1 1.67-.09l.1.09L27.5 66.11a1.25 1.25 0 0 1-1.66 1.86l-.1-.09-12.08-12.07a1.27 1.27 0 0 1 0-1.77Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M68 0H14.25A14.29 14.29 0 0 0 0 14.25V68a14.29 14.29 0 0 0 14.25 14.25H68A14.29 14.29 0 0 0 82.25 68V14.25A14.29 14.29 0 0 0 68 0ZM14.25 2.5H68a11.79 11.79 0 0 1 11.75 11.75V68A11.79 11.79 0 0 1 68 79.75H14.25A11.79 11.79 0 0 1 2.5 68V14.25A11.79 11.79 0 0 1 14.25 2.5Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'SquareWithPlusMinusMultiplyEqualQuadrantsIcon';

export default Icon;
